export const CLOSEAPP = 'CLOSEAPP'
export const KEY_STROKES = 'KEY_STROKES'
export const ADD_LOCATION = 'ADD_LOCATION'
export const DRAG_AND_DROP = 'DRAG_AND_DROP'
export const OPENAPP = 'OPENAPP'
export const SWITCHAPP = 'SWITCHAPP'
export const SCREENSHOT = 'SCREENSHOT'
export const CLOSE = 'CLOSE'
export const DATA_SCRAPE = 'DATA_SCRAPE'
